/**
 * Language Switcher Module
 * Handles language switching and translation of page content
 */ (function($) {
    'use strict';
    // Default language
    const DEFAULT_LANG = 'en';
    const STORAGE_KEY = 'sam-apps-language';
    /**
     * Language Switcher Class
     */ class LanguageSwitcher {
        constructor(translations1){
            this.translations = translations1;
            this.currentLang = this.getStoredLanguage() || this.detectBrowserLanguage() || DEFAULT_LANG;
            this.init();
        }
        /**
         * Initialize the language switcher
         */ init() {
            const self = this;
            // Wait for jQuery to be ready
            const initWhenReady = function() {
                if (typeof jQuery === 'undefined' || typeof $ === 'undefined') {
                    setTimeout(initWhenReady, 50);
                    return;
                }
                // Apply current language on page load
                $(document).ready(function() {
                    self.applyLanguage(self.currentLang);
                    self.updateLanguageSwitcherUI();
                });
                // Handle language switcher clicks - support both dropdown-item and language-menu-item
                $(document).on('click', '[data-lang]', function(e) {
                    // Only handle if it's a language switcher element
                    const $target = $(this);
                    if ($target.hasClass('dropdown-item') || $target.hasClass('language-menu-item')) {
                        e.preventDefault();
                        e.stopPropagation();
                        const lang = $target.data('lang');
                        if (lang) {
                            self.switchLanguage(lang);
                            // Close Bootstrap dropdown if present
                            const $dropdown = $target.closest('.dropdown');
                            if ($dropdown.length) {
                                $dropdown.removeClass('show');
                                $dropdown.find('.dropdown-menu').removeClass('show');
                                $dropdown.find('button').attr('aria-expanded', 'false');
                            }
                        }
                    }
                });
            };
            initWhenReady();
        }
        /**
         * Get stored language from localStorage
         */ getStoredLanguage() {
            try {
                return localStorage.getItem(STORAGE_KEY);
            } catch (e) {
                console.warn('localStorage not available:', e);
                return null;
            }
        }
        /**
         * Store language preference
         */ storeLanguage(lang) {
            try {
                localStorage.setItem(STORAGE_KEY, lang);
            } catch (e) {
                console.warn('localStorage not available:', e);
            }
        }
        /**
         * Detect browser language
         */ detectBrowserLanguage() {
            const browserLang = navigator.language || navigator.userLanguage;
            const langCode = browserLang.split('-')[0].toLowerCase();
            // Check if we have translations for this language
            if (this.translations[langCode]) return langCode;
            return null;
        }
        /**
         * Switch to a different language
         */ switchLanguage(lang) {
            console.log(`Switching to language: ${lang}`);
            if (!this.translations[lang]) {
                console.warn(`Language ${lang} not available`);
                return;
            }
            this.currentLang = lang;
            this.storeLanguage(lang);
            this.applyLanguage(lang);
            this.updateLanguageSwitcherUI();
            // Update HTML lang attribute
            document.documentElement.setAttribute('lang', lang);
            // Trigger custom event for other scripts
            $(document).trigger('languageChanged', [
                lang
            ]);
            console.log(`Language switched to: ${lang}`);
        }
        /**
         * Apply translations to the page
         */ applyLanguage(lang) {
            const t = this.translations[lang];
            if (!t) {
                console.warn(`Translations for ${lang} not found`);
                return;
            }
            console.log(`Applying language: ${lang}`);
            // Translate elements with data-i18n attribute
            const $i18nElements = $('[data-i18n]');
            console.log(`Found ${$i18nElements.length} elements with data-i18n`);
            $i18nElements.each((index, element)=>{
                const $el = $(element);
                const key = $el.data('i18n');
                const translation = t[key];
                if (translation) {
                    // Check if element is input/textarea (for placeholders)
                    if ($el.is('input') || $el.is('textarea')) {
                        if ($el.attr('placeholder')) $el.attr('placeholder', translation);
                        else $el.val(translation);
                    } else // For other elements, update text content
                    $el.text(translation);
                } else console.warn(`Translation key "${key}" not found for language ${lang}`);
            });
            // Translate elements with data-i18n-html (for HTML content)
            $('[data-i18n-html]').each((index, element)=>{
                const $el = $(element);
                const key = $el.data('i18n-html');
                const translation = t[key];
                if (translation) $el.html(translation);
            });
            // Translate title attributes
            $('[data-i18n-title]').each((index, element)=>{
                const $el = $(element);
                const key = $el.data('i18n-title');
                const translation = t[key];
                if (translation) $el.attr('title', translation);
            });
            // Translate aria-label attributes
            $('[data-i18n-aria]').each((index, element)=>{
                const $el = $(element);
                const key = $el.data('i18n-aria');
                const translation = t[key];
                if (translation) $el.attr('aria-label', translation);
            });
        }
        /**
         * Update language switcher UI to reflect current language
         */ updateLanguageSwitcherUI() {
            const lang = this.currentLang;
            const langNames = {
                'en': 'English',
                'uk': "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430",
                'es': "Espa\xf1ol",
                'fr': "Fran\xe7ais",
                'de': 'Deutsch'
            };
            const langFlags = {
                'en': 'assets/images/flags/en.png',
                'uk': 'assets/images/flags/en.png',
                'es': 'assets/images/flags/en.png',
                'fr': 'assets/images/flags/fr.png',
                'de': 'assets/images/flags/de.png'
            };
            // Update dropdown button text
            const $currentLangSpan = $('.current-language');
            if ($currentLangSpan.length) $currentLangSpan.text(lang.toUpperCase());
            // Update active state in dropdown items
            $('.dropdown-item[data-lang]').removeClass('active');
            $('.dropdown-item[data-lang="' + lang + '"]').addClass('active');
            // Update language-menu structure if it exists (for flag-based menu)
            const $mainItem = $('.language-menu > ul > li > a.language-menu-item');
            if ($mainItem.length) {
                const langName = langNames[lang] || lang.toUpperCase();
                const flagSrc = langFlags[lang] || langFlags['en'];
                $mainItem.find('.ls-flag').attr('src', flagSrc).attr('alt', lang).attr('title', langName);
                $mainItem.find('.wpml-ls-native').text(langName);
                $mainItem.attr('data-lang', lang);
            }
            // Update submenu to show other available languages (excluding current)
            const $submenu = $('.language-menu .ls-sub-menu');
            if ($submenu.length) {
                const availableLangs = Object.keys(this.translations);
                $submenu.empty();
                availableLangs.forEach((l)=>{
                    if (l !== lang) {
                        const langName = langNames[l] || l.toUpperCase();
                        const flagSrc = langFlags[l] || langFlags['en'];
                        const $subItem = $('<li></li>');
                        const $subLink = $('<a href="index.html#" class="language-menu-item" data-lang="' + l + '"></a>');
                        $subLink.append($('<img class="ls-flag" src="' + flagSrc + '" alt="' + l + '" title="' + langName + '">'));
                        $subLink.append($('<span class="wpml-ls-native">' + langName + '</span>'));
                        $subItem.append($subLink);
                        $submenu.append($subItem);
                    }
                });
            }
        }
        /**
         * Get current language
         */ getCurrentLanguage() {
            return this.currentLang;
        }
        /**
         * Get translation for a key
         */ translate(key, lang = null) {
            const language = lang || this.currentLang;
            const t = this.translations[language];
            return t && t[key] ? t[key] : key;
        }
    }
    // Initialize language switcher when translations are loaded
    // Wait for both jQuery and translations to be available
    function initLanguageSwitcher() {
        if (typeof translations !== 'undefined' && typeof jQuery !== 'undefined' && typeof $ !== 'undefined') try {
            window.languageSwitcher = new LanguageSwitcher(translations);
            console.log('Language switcher initialized successfully');
        } catch (e) {
            console.error('Error initializing language switcher:', e);
        }
        else {
            // Retry after a short delay if not ready
            if (typeof window !== 'undefined' && window.initLanguageSwitcherRetries === undefined) window.initLanguageSwitcherRetries = 0;
            if (window.initLanguageSwitcherRetries < 50) {
                window.initLanguageSwitcherRetries++;
                setTimeout(initLanguageSwitcher, 100);
            } else console.error('Language switcher initialization failed: jQuery or translations not available');
        }
    }
    // Start initialization when DOM is ready
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLanguageSwitcher);
    else // DOM already loaded, but wait a bit for jQuery
    setTimeout(initLanguageSwitcher, 100);
})(jQuery);

//# sourceMappingURL=about-us-01.e83bb950.js.map
